import { REBRAND_BODY_CLASS } from './rebrand-body-class.const';

const REBRAND_STORAGE_KEY = 'rebrand_enabled';

export const applyRebrandBodyClass = (rebrandEnabled: boolean): void => {
  document.body.classList.toggle(REBRAND_BODY_CLASS, rebrandEnabled);

  localStorage.setItem(REBRAND_STORAGE_KEY, String(rebrandEnabled));
};

export const applyStoredRebrandBodyClass = (): void => {
  const rebrandEnabled = localStorage.getItem(REBRAND_STORAGE_KEY) === String(true);

  document.body.classList.toggle(REBRAND_BODY_CLASS, rebrandEnabled);
};
